import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Loader } from 'src/components/common/Loader';
import { Typography } from 'src/components/common/Typography';
import { CmsMeta, getCanonicalUrl, SeoHelmet, toSeoMeta } from 'src/helpers/seo';
import { RootState } from 'src/types/store-types';
import _styles from './Styles.module.scss';

type BottomNavItem = {
  name?: string;
  slug?: string;
  content?: string;
  meta?: CmsMeta;
};

export const InfoAndRulesPage: FC<{ name: string; slug: string }> = ({ name, slug }) => {
  const { t }: Translation = useTranslation();
  const { pathname } = useLocation();

  const ref = useRef<HTMLDivElement | null>(null);

  const { bottomNavigation } = useSelector((state: RootState) => state.configs);
  const [currentItem, setCurrentItem] = useState<BottomNavItem | null>(null);
  const content = currentItem?.content ?? null;
  const meta = toSeoMeta(currentItem?.meta);

  useEffect(() => {
    if (bottomNavigation?.length && (slug || name)) {
      const item =
        bottomNavigation?.find((navItem: BottomNavItem) => navItem.name === name || navItem.name === slug) || null;
      setCurrentItem(item);
      ref?.current?.scrollTo({ behavior: 'smooth', top: 0 });
    }
  }, [slug, name, bottomNavigation]);

  if (!content) {
    return (
      <div className={_styles.info_container}>
        <div className={_styles.loader_wrapper}>
          <Loader size="lg" />
        </div>
      </div>
    );
  }

  return (
    <div className={_styles.info_container} ref={ref}>
      <SeoHelmet
        category={currentItem?.name || currentItem?.slug || 'info-and-rules'}
        meta={meta}
        canonicalUrl={getCanonicalUrl(pathname)}
      />
      {Boolean(content) ? (
        <div dangerouslySetInnerHTML={{ __html: content }} />
      ) : (
        <div className="no_data_container">
          <Typography variant={'h5'}>{t('no_data')}</Typography>
        </div>
      )}
    </div>
  );
};
